<template>
  <b-row class="justify-content-center mt-2">
    <b-col
      cols="12"
      md="10"
      lg="8"
    >
      <b-card :title="$t('user.profile.title')">
        <validation-observer ref="refProfileForm">
          <b-form @submit.prevent="save">
            <b-form-group
              :label="$t('auth.register.firstname')"
              label-for="first-name"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('auth.register.firstname')"
                rules="required"
              >
                <b-form-input
                  id="first-name"
                  v-model="user.firstName"
                  :state="errors[0] ? false : null"
                  autocomplete="given-name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              :label="$t('auth.register.lastname')"
              label-for="last-name"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('auth.register.lastname')"
                rules="required"
              >
                <b-form-input
                  id="last-name"
                  v-model="user.lastName"
                  :state="errors[0] ? false : null"
                  autocomplete="family-name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              :label="$t('auth.your-email')"
              label-for="email"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('auth.your-email')"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="user.email"
                  :state="errors[0] ? false : null"
                  autocomplete="email"
                />
                <b-form-text class="text-muted">
                  {{ $t('user.profile.email-change-note') }}
                </b-form-text>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              :label="$t('auth.register.phone')"
              label-for="phone-number"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('auth.register.phone')"
                rules="required"
              >
                <vue-tel-input
                  v-model="user.phoneNumber"
                  mode="international"
                  default-country="PL"
                  :dropdown-options="{ showFlags: true, showDialCodeInSelection: false, showSearchBox: true }"
                  :input-options="{ placeholder: '', showDialCode: false }"
                  :valid-characters-only="true"
                  autocomplete="chrome-off"
                  :class="{ 'border-danger': !phoneNumberValid || !!errors.length }"
                  @validate="handlePhoneValidation"
                />
                <small
                  v-if="errors.length"
                  class="text-danger"
                >{{ errors[0] }}</small>
                <small
                  v-else-if="!phoneNumberValid"
                  class="text-danger"
                >{{ $t('validations.messages.phone-number-invalid') }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              :label="$t('user.profile.timezone')"
              label-for="timezone"
            >
              <b-form-select
                id="timezone"
                v-model="user.timezone"
                :options="timezoneOptions"
              />
            </b-form-group>

            <b-form-group v-if="isTeacher">
              <rc-label
                for="short-name"
                :description="$t('user.profile.calendar-public-url-description')"
              >
                {{ $t('user.profile.calendar-public-url') }}
              </rc-label>
              <b-input-group>
                <b-form-input
                  :value="publicCalendarUrl"
                  disabled
                  readonly
                />
                <b-input-group-append>
                  <b-button
                    v-b-tooltip
                    variant="outline-secondary"
                    :title="$t('shared.btn.copy')"
                    @click="copyCalendarUrl"
                  >
                    <feather-icon icon="CopyIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-button
              type="submit"
              variant="primary"
              :disabled="processing"
              class="mt-1"
            >
              <b-spinner
                v-if="processing"
                small
              />
              {{ $t('shared.btn.save') }}
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RcLabel from '@/layouts/components/rc/RcLabel.vue'
import profileEditSetup from './profileEditSetup'

export default {
  components: {
    RcLabel,
    ValidationObserver,
    ValidationProvider,
  },
  setup: profileEditSetup,
}
</script>

<style scoped>
</style>
